<ng-container *transloco="let t">
  <editable-text
    appNavBreadcrumb
    [label]="productGroup?.productGroupName ?? ''"
    [disable]="isReadOnly"
    (textChange)="changeName($event)"
  />
  @if (productGroup === null) {
    <div class="w-100 h-100 flex items-center justify-center">
      <div class="flex flex-col items-center">
        <h3 class="text-center">{{ t("product-group-page.product_group_not_found") }}</h3>
        <p class="text-center">{{ t("product-group-page.not_found_details") }}</p>
      </div>
    </div>
  } @else {
    <div class="mb-3">
      @if (!isReadOnly) {
        <div class="flex justify-end gap-2">
          <IButton
            color="white"
            [label]="editMode ? t('common.close') : t('product-group-page.edit_asins')"
            [icon]="!editMode ? ICON_EDIT_O : ICON_CLOSE"
            (onClick)="editMode = !editMode; newAsins = []"
          />
          @if (newAsins.length) {
            <IButton [label]="t('common.save')" (onClick)="updateProductGroupProducts(newAsins)" />
          }
        </div>
      }
    </div>

    <div class="h-[70vh]">
      <app-asin-selection
        [selectedAsins]="editMode ? alreadySelectedProducts! : []"
        [customList]="editMode ? undefined : alreadySelectedProducts!"
        (selectedAsinsChange)="newAsins = $event"
        [csvExport]="false"
        [readonly]="!editMode && !isReadOnly"
      />
    </div>
  }
</ng-container>
